import { Component, Input, OnInit } from '@angular/core';
import { Station } from '../interfaces/station.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  @Input() station: Station;
  phoneNumber: string = environment.contacto.telefono;

  constructor() { }

  ngOnInit(): void {
  }

}
